<template lang="">
    <div id='chart' class='bg-site-primary p-2 ' v-if="userInfo.listMonths &&Object.keys(userInfo.listMonths).length > 0 " >
     <apexchart  height='200' type="bar" :options="chartOptions" :series="series"></apexchart>
</div>
</template>
<script setup>
import { ref, computed } from 'vue';
import { UserInfo } from '@/stores/UserInfo';

const userInfo = ref(UserInfo());



const series = computed(() => [
  {
    name: "Weight",
    data: Object.keys(userInfo.value.listMonths).map(monthKey => ({
      x: parseInt(monthKey),
      y: (userInfo.value.listMonths[monthKey].weightStart - userInfo.value.listMonths[monthKey].weightEnd).toFixed(2),
    })),
  },
]);

const chartOptions = {
  chart: {
    zoom: {
      enabled: false
    }
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: 'Months change',
    align: 'left'
  },
  xaxis: {
    type: 'category',
  },
  yaxis: {
    
    opposite: true,
    labels: {
      formatter: function (value) {
        return value.toFixed(1); 
      },
    },
  },
  legend: {
  
  }
};
</script>